<template>
  <div>
    <div ref="container" class="v-waterfall-content">
      <div ref="left" class="left"></div>
      <div ref="right" class="right"></div>
    </div>
    <div
      class="flex-column justify-content-center align-items-center big-image"
      v-if="img"
      @click="img = undefined"
    >
      <img :src="img" style="width: 100vw" />
    </div>
  </div>
</template>

<script>
import like from "@/assets/home_new/onTheGo/like.png";
import like1 from "@/assets/home_new/onTheGo/like1.png";
import { getMImageList, likeApi } from "@/api/home";
import { VUE_APP_API_URL } from "@utils";
//随手拍 我的
export default {
  name: "waterfall2",
  components: {},
  data() {
    return {
      img: undefined,
      page: 0,
      size: 10,
      route: {},
      timeId: null,
      div: {},
      left: {},
      right: {},
      imgWidth: 220,
      like: like,
      imgsArr: [],
      count: 0,
      gap: 10,
      times: {}
    };
  },
  created() {
    this.route = this.$route.query;
    this.initData();
  },
  mounted() {
    this.div = this.$refs.container;
    this.left = this.$refs.left;
    this.right = this.$refs.right;
    this.imgWidth = this.div.clientWidth / 2 - 20 + "px";
    //绑定事件
    // this.change();
  },
  destroyed() {},
  methods: {
    creatImg() {
      //创建img元素
      if (this.count >= this.imgsArr.length) {
        return;
      }
      var width = this.left.clientWidth;
      var obj = this.imgsArr[this.count];
      var src = `${VUE_APP_API_URL}/home/getImage?id=` + obj.imageS; //循环拿到照片
      var avatar = obj.avatar; //循环拿到照片
      var nickname = obj.nickname; //循环拿到照片
      var leftHeight = 0;
      for (const children of this.left.children) {
        leftHeight = leftHeight + children.clientHeight + this.gap;
      }
      var rightHeight = 0;
      for (const children of this.right.children) {
        rightHeight = rightHeight + children.clientHeight + this.gap;
      }
      var div = document.createElement("div"); //创建img元素
      div.className = "item-group";
      div.style.width = width + "px";
      div.style.height = "auth"; //设置图宽度
      div.style.backgroundColor = "#ffffff";
      div.style.marginTop = this.gap + "px"; //设置图宽度
      div.style.borderRadius = "0.2rem";

      var img = document.createElement("img"); //创建img元素
      img.style.borderTopLeftRadius = "0.2rem"; //设置图宽度
      img.style.borderTopRightRadius = "0.2rem"; //设置图宽度
      img.src = src; //设置图片的src地址
      img.style.width = width + "px"; //设置图宽度
      img.style.height = "auth"; //设置图宽度

      img.style.objectFit = "fill";
      img.style.whiteSpace;
      img.id = this.count;
      img.onclick = function(res) {
        var obj1 = _this.imgsArr[res.currentTarget.id];
        if (obj1.route) {
          _this.$router.push({ path: obj1.route });
        }
      };
      if (leftHeight <= rightHeight) {
        this.left.appendChild(div);
      } else {
        this.right.appendChild(div);
      }
      div.append(img);

      var div2 = document.createElement("div"); //创建img元素
      div2.className = "item-div";
      div2.style.display = "flex";
      div2.style.flexDirection = "row";
      div2.style.justifyContent = "flex-start";
      div2.style.paddingLeft = "10px";
      div2.style.fontSize = "0.2rem";
      div2.style.marginBottom = "0.2rem";

      var div3 = document.createElement("div"); //创建img元素
      div3.style.width = "calc(100% - 1.2rem)";
      div3.className = "desc-div";
      div3.style.display = "flex";
      div3.style.flexDirection = "row";
      div3.style.justifyContent = "flex-start";
      div3.style.alignItems = "center";
      div2.style.paddingRight = "10px";

      var div4 = document.createElement("div"); //创建img元素
      div4.className = "like";
      div4.style.width = "1.2rem";
      div4.className = "desc-div";
      div4.style.display = "flex";
      div4.style.flexDirection = "row";
      div4.style.justifyContent = "flex-start";
      div4.style.alignItems = "center";

      var i = document.createElement("i"); //创建img元素
      i.innerText = this.imgsArr[this.count].descText;
      i.style.fontFamily = "JDZY";
      i.style.fontSize = "0.25rem";
      // i.style.letterSpacing = "0.1rem"
      var descDiv = document.createElement("div"); //创建img元素
      descDiv.style.padding = "0.1rem 0.2rem 0.1rem 0.2rem";
      descDiv.style.lineHeight = "0.35rem";
      div.appendChild(descDiv);
      descDiv.appendChild(i);
      // div.appendChild(i);
      div.appendChild(div2);
      div2.appendChild(div3);
      div2.appendChild(div4);

      var img2 = document.createElement("img"); //创建img元素
      img2.style.width = "0.4rem";
      img2.style.borderRadius = "0.2rem";
      img2.src = avatar;
      var i2 = document.createElement("i"); //创建img元素
      i2.style.fontSize = "0.3rem";
      i2.innerText = nickname;
      i2.style.marginLeft = "0.1rem";

      div3.appendChild(img2);
      div3.appendChild(i2);
      var img3 = document.createElement("img"); //创建img元素
      img3.style.width = "0.35rem";
      var i3 = document.createElement("i"); //创建img元素
      i3.innerText = obj.vCount;
      i3.style.marginLeft = "0.1rem";
      if (obj.vLike === 0) {
        img3.src = like;
      } else {
        img3.src = like1;
      }

      img3.id = this.count;
      img3.onclick = function(res) {
        if (_this.times[img3.id] === 1){
          return
        }
        if (obj.vLike === 0) {
          img3.src = like1;
          obj.vLike = 1;
          obj.vCount = obj.vCount + 1;
        } else {
          img3.src = like;
          obj.vLike = 0;
          obj.vCount = obj.vCount - 1;
        }
        i3.innerText = obj.vCount;
        _this.times[img3.id] = 1;
        setTimeout(function () {
          _this.times[img3.id] = 0
        },3000)
        _this.likeF(res);
      };

      div4.appendChild(img3);
      div4.appendChild(i3);
      //排列每一张图片
      var _this = this;
      img.onclick = function(res) {
        var obj1 = _this.imgsArr[res.currentTarget.id];
        _this.img = `${VUE_APP_API_URL}/home/getSImage?id=` + obj1.image; //循环拿到照片
      };
      img.onload = function() {
        _this.count++;
        _this.creatImg();
      };
    },
    likeF(res) {
      var obj = this.imgsArr[res.currentTarget.id];
      var params = {
        id: obj.picId
      };
      likeApi(params)
        .then(res1 => {})
        .catch(e => {
          console.info(e);
        });
    },
    initData() {
      var params = {
        page: this.page,
        size: this.size
      };
      getMImageList(params)
        .then(res => {
          console.info(res);
          this.imgsArr = res.data;
          //加入图片初始化操作
          this.creatImg();
        })
        .catch(e => {
          console.info(e);
        });
    }
  }
};
</script>

<style scoped>
@import "../../assets/css/font-title.css";

.big-image {
  position: fixed;
  width: 100vw;
  top: 0;
  left: 0;
  height: 100vh;
  z-index: 999;
  background: #00000099;
}

.v-waterfall-content {
  display: flex;
  flex-direction: row;
  width: 100%;
  gap: 10px;
  margin-bottom: 20px;
}

.left {
  width: calc(50% - 5px);
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  height: auto;
}

.right {
  width: calc(50% - 5px);
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  height: auto;
}

/* 图片样式 */
.v-waterfall-content img {
  position: absolute;
  transition: all 0.5s;
  width: 220px;
}

.item-group {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
}

.item-div {
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
}

.desc-div {
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding-left: 10px;
}

.like {
  width: 1rem;
  flex-direction: row;
  justify-content: flex-end;
}
</style>
